import { createResponse } from '../response'

const normalizeWorldCreditsResponse = (data) => {
  let products = []
  data.products.forEach(function (item) {
    let normalized = theirWorldCreditToOurWorldCredit(item)
    products.push(normalized)
  })
  let res = {}
  res.products = createResponse(products)
  return res
}

const theirWorldCreditToOurWorldCredit = (data) => {
  let normalized = {
    'id': data.productId,
    'price': data.productPrice,
    'purchasable': data.purchasable
  }
  return normalized
}

const createResponseByProductId = (data) => {
  let res = {}
  Object.keys(data).forEach((key) => {
    let product = data[key]

    res[product.productId] = createSingleProductResponse(product)
  })
  return res
}

const createSingleProductResponse = (product) => {
  product.pricePerPeriod = product.productPrice

  if (product.validForPeriod > 30) {
    let currencySymbol = product.productPrice.formatted.replace(product.productPrice.formatted.match(/[-+]?[0-9]*\.*\,?[0-9]+/)[0], '').replace(' ', '')
    product.pricePerPeriod = {
      amount: product.productPrice.amount / (product.validForPeriod / 30),
      formatted: '',
      currencyId: product.productPrice.currencyId
    }

    let amount = parseFloat(product.pricePerPeriod.amount.toString().substring(0, product.pricePerPeriod.amount.toString().indexOf('.') + 3))

    product.pricePerPeriod.amount = parseFloat(amount)

    if (product.productPrice.currencyId === 'EUR' || product.productPrice.currencyId === 'SEK' || product.productPrice.currencyId === 'PLN') {
      product.pricePerPeriod.formatted = `${amount.toString()} ${currencySymbol}`
    } else {
      product.pricePerPeriod.formatted = `${currencySymbol}${amount.toString()}`
    }
  }

  return product
}

export {
  normalizeWorldCreditsResponse,
  theirWorldCreditToOurWorldCredit,
  createResponseByProductId,
  createSingleProductResponse
}



// WEBPACK FOOTER //
// ./src/api/sales/normalize.js